module.exports = __webpack_public_path__ + "static/media/star.20d12498.svg";